
const FormError = ({ children, addClasses = false, id }) => {
    if (children) {
        return (
            <p id={id} className={`text-red mb-1 ${addClasses ? addClasses : 'text-xs'}`} aria-live="polite">
                { children }
            </p>
        )
    } else {
        return (
            <></>
        )
    }
}

export default FormError